import PolicyLayout from "../components/PolicyLayout";

const ShippingPolicyPage = () => {
  return (
    <PolicyLayout title="Shipping Policy" lastUpdated="February 2026">
      <p className="text-base leading-relaxed mb-6">
        At <strong>theSnugglePrints</strong>, every order is custom-made — from
        AI generation to premium printing and careful packaging. This policy
        outlines how we ship your order, both within India and internationally.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">1. Shipping Coverage</h3>
      <p className="text-base leading-relaxed mb-3">
        We ship across <strong>India</strong> to all serviceable pincodes, and
        we are now expanding internationally. Currently supported international
        destinations are grouped into the following markets:
      </p>
      <ul className="list-disc ml-6 space-y-2 mb-3">
        <li>
          <strong>Emerging Markets:</strong> United Arab Emirates, Saudi
          Arabia, Malaysia, Thailand, Brazil, Mexico, South Africa, Indonesia,
          Philippines
        </li>
        <li>
          <strong>Developed Markets:</strong> United States, Canada, United
          Kingdom, Germany, France, Netherlands, Belgium, Italy, Spain,
          Austria, Singapore, Japan, South Korea, New Zealand
        </li>
        <li>
          <strong>Premium Markets:</strong> Switzerland, Norway, Denmark,
          Sweden, Finland, Iceland, Luxembourg
        </li>
      </ul>
      <p className="text-base leading-relaxed mb-6">
        If your country isn't on the list, please email{" "}
        <strong>contact@thesnuggleprints.com</strong> — we may still be able to
        arrange shipping on a case-by-case basis.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">2. Production Time</h3>
      <p className="text-base leading-relaxed mb-3">
        Every order is printed on-demand. Standard production timelines are:
      </p>
      <ul className="list-disc ml-6 space-y-2 mb-3">
        <li>
          <strong>Frames, Canvas, Acrylic Stands, Mugs:</strong> 1–2 business
          days of production after order confirmation.
        </li>
        <li>
          <strong>Photo Books (printed):</strong> 1–2 business days of
          production, preceded by 2–3 business days of design consultation —
          our team works with you over email to shape the storyline, pick the
          best photos, and share a draft for your review before we send it to
          print.
        </li>
        <li>
          <strong>Photo Book Video:</strong> the final video is shared with you
          within 2–3 business days of placing your order.
        </li>
      </ul>
      <p className="text-base leading-relaxed mb-6">
        Please note: if there is a delay from your side — sharing photos,
        providing descriptions, or approving the draft — the overall timeline
        will extend accordingly.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">3. Delivery Time</h3>
      <p className="text-base leading-relaxed mb-3">
        After dispatch, standard delivery times are:
      </p>
      <ul className="list-disc ml-6 space-y-2 mb-3">
        <li>
          <strong>Within India:</strong> 3–7 business days (metros usually 3–5,
          remote / North-East regions may take up to 10 business days).
        </li>
        <li>
          <strong>International:</strong> approximately 4–10 business days,
          depending on destination and customs clearance.
        </li>
      </ul>
      <p className="text-base leading-relaxed mb-6">
        Delays may occur during festivals, peak seasons, weather events, or for
        pincodes with limited courier coverage.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">4. Shipping Charges</h3>
      <p className="text-base leading-relaxed mb-6">
        Shipping is <strong>FREE worldwide</strong> on all orders. No hidden
        charges at checkout.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">5. Customs &amp; Import Duties (International)</h3>
      <p className="text-base leading-relaxed mb-6">
        Any customs or import duties applied by your country, if any, will be{" "}
        <strong>borne by theSnugglePrints</strong>. If you are charged duties
        upon delivery, simply email us your receipt and we will{" "}
        <strong>reimburse you in full</strong> within a few business days.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">6. Order Tracking</h3>
      <p className="text-base leading-relaxed mb-6">
        Once your order is dispatched, you will receive an email (and SMS, if
        phone provided) with the courier name and tracking number. If you
        haven't received dispatch details within the production timeline above,
        email us at <strong>contact@thesnuggleprints.com</strong> with your
        order reference number.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">7. Address Accuracy</h3>
      <p className="text-base leading-relaxed mb-6">
        Please double-check the shipping address entered at checkout. Once an
        order enters production, we <strong>cannot modify the address</strong>.
        Orders returned due to incorrect addresses or unavailability of the
        recipient will be re-shipped at the customer's cost.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">8. Damaged / Lost Shipments</h3>
      <p className="text-base leading-relaxed mb-6">
        If your package arrives damaged, please refuse delivery or accept it
        only after photographing the damage. Report the issue within{" "}
        <strong>48 hours of delivery</strong> to{" "}
        <strong>contact@thesnuggleprints.com</strong> along with photos. See our{" "}
        <a href="/refund-policy" className="underline font-medium">
          Refund &amp; Cancellation Policy
        </a>{" "}
        for replacement options.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">9. Contact</h3>
      <p className="text-base leading-relaxed mb-6">
        Shipping-related questions?
        <br />
        Email: <strong>contact@thesnuggleprints.com</strong>
        <br />
        Hours: Mon–Sat, 10:00–19:00 IST
      </p>
    </PolicyLayout>
  );
};

export default ShippingPolicyPage;
